import { PersonalAccessToken } from '@mapped/schema-graph-react-apollo'
import { FunctionComponent } from 'react'
import { IDocsData } from '../../../../pages/[...id]'
import { Layout } from '../../../layout'
import { PageTitle } from '../../../layout/pageTitle'
import { MarkdownRenderer } from '../../../markdown'
import { AccessToken } from './accessToken'

export const PersonalAccessTokenSection: FunctionComponent<ITokenPage> = ({
  data,
  tokensList,
  isLogged,
  scopesDescription,
}) => {
  return (
    <Layout data={data} direction="row">
      <PageTitle title={data?.selectedContent?.title!} withBorder={true} />
      <MarkdownRenderer>{data?.selectedContent?.body}</MarkdownRenderer>

      <AccessToken
        scopesDescription={scopesDescription}
        tokensList={tokensList}
        isLogged={isLogged}
      />
    </Layout>
  )
}

interface ITokenPage {
  data: IDocsData
  tokensList: PersonalAccessToken[]
  scopesDescription: IScopesDescription[]
  isLogged?: boolean
}

export interface IScopesDescription {
  title: string
  description: string
}

export interface IAnchorManagement {
  selectedAnchor: string
  setSelectedAnchor: (anchor: string) => void
}
